import React from "react"
import { VictoryChart, VictoryLine, VictoryScatter, VictoryAxis, VictoryBar } from "victory"

import "./MultilineChart"

const xOffsets = [0, 0];
const tickPadding = [ -7, +6 ];
const anchors = ["end", "end"];

const colors = [
  // { label: "#333333", axis: "#333",    ticks: "#333333", graph: "#8598B0" },
  { label: "#70877E", axis: "#70877E", ticks: "#70877E", graph: "#8FA099" },
  { label: "#d03b65", axis: "#d03b65", ticks: "#d03b65", graph: "#d03b65" },
]

const axisStyle = i => ({
  axis: { 
    stroke: colors[i].axis
  },
  ticks: { 
    padding: tickPadding[i],
    stroke: "black",
    strokeWidth: 0
  },
  tickLabels: { 
    fill: colors[i].ticks,
    textAnchor: "end", 
    fontSize: 8
  },
  axisLabel: { 
    fill: colors[i].label, 
    //textAnchor: "end", 
    fontSize: 8,
    angle: i == 0 ? 270 : 90
  },
})

const mainAxisStyle = ({
  axis: { 
    stroke: colors[0].axis
  },
  ticks: { 
    padding: tickPadding[0],
    stroke: "black",
    strokeWidth: 0
  },
  tickLabels: { 
    fill: colors[0].ticks,
    textAnchor: "end", 
    fontSize: 8 
  },
  axisLabel: { 
    fill: colors[0].label,
    textAnchor: "end", 
    fontSize: 8 
  },
})


function MultilineChart({ graphData }) {
  const maxima = graphData.map(
    (dataset) => Math.max(...dataset.map((d) => d.y))
  )
  
  console.log({ graphData, maxima })

  return (
    <React.Fragment>
      <div className="MultilineChart">
        <VictoryChart
          height={200}
          domain={{ y: [0, 1] }}
          style={{
            tickLabels: {
              fill: "black",
              fontFamily: "inherit",
              fontSize: 16
            }
          }}
        >
          <VictoryBar
            __data={graphData[0].map(({ x, y }) => ({ x, y: (y / parseInt(x)) }))}
            data={graphData[0]}
            style={{ data: { fill: colors[0].graph } }}
            y={(datum) => datum.y / maxima[0]}            
          />
          <VictoryLine
            data={graphData[1]}
            y={(datum) => datum.y / maxima[1]}
            style={{ data: { stroke: colors[1].graph, strokeWidth: 1.3 } }}
            interpolation="monotoneX"
          />
          <VictoryScatter
            data={graphData[1]}
            style={{ data: { fill: colors[1].graph } }}
            y={(datum) => datum.y / maxima[1]}
            size={1.2}
          />
          
          <VictoryAxis 
            label="Day"
            style={mainAxisStyle} 
            tickValues={[1, 2, 3, 4]}
            offsetY={43}
          />
          {
            ["Daily sales", "Daily earnings"].map((label, i) => ( 
              <VictoryAxis dependentAxis
                data={graphData[i]}
                label={label}
                offsetX={45}
                key={i}
                orientation={i == 0 ? "left" : "right"}
                style={axisStyle(i)}
                tickValues={[0.25, 0.5, 0.75, 1]}
                tickFormat={(t) => Math.floor(t * maxima[i])}
              />
            ))
          }
        </VictoryChart>
      </div>
      {/* <code className="c0">{graphData[0].map(({x, y}) => `${x}:${y}`).join(" - ")}</code> */}
      {/* <code className="c1">{graphData[1].map(({x, y}) => `${x}:${y}`).join(" - ")}</code> */}
    </React.Fragment>
  )
}

export default MultilineChart



// WEBPACK FOOTER //
// ./src/app/admin/components/MultilineChart.jsx